import { AuthorizedProduct } from '../SidePanel/SidePanel';

const AuthorizationAPI = ({
  getAuthorizedProducts(): Promise<AuthorizedProduct[]> {
    return new Promise((resolve) => {
      resolve(
        [
          {
            idtProduct: 1350,
            name: 'Loja Virtual',
            url: 'https://painelstore.host.uol.com.br',
          },
          {
            idtProduct: 1744,
            name: 'Loja Pronta',
            url: 'https://loja.host.uol.com.br/panel/loja-pronta/panel_page',
          },
          {
            idtProduct: 1351,
            name: 'Domínios',
            url: 'https://paineldominios.uol.com.br/web/home',
          },
          {
            idtProduct: 1349,
            name: 'E-mail Profissional',
            url: 'https://painel-email.uol.com.br',
          },
          {
            idtProduct: 1347,
            name: 'E-mail Marketing',
            url: 'https://emailmkt.host.uol.com.br/login.html',
          },
          {
            idtProduct: 2225,
            name: 'UOL Anúncios',
            url: 'https://painel-uol-anuncio.host.uol.com.br',
          },
          {
            idtProduct: 2269,
            name: 'Agendador',
            url: 'https://agendador.producthub.uol.com.br/home',
          },
        ],
      );
    });
  },
});

export default AuthorizationAPI;
